import { create } from 'zustand';
import { ImoduleFilter, ISortFilter, SORT_ORDER } from 'types/global';
import { IProductList } from 'types/orders';
import { IFocusedFilterValuesMap, TFocusedFilterValue } from '../OrdersTrackingOperationsFilters/filter.constants';

interface IState {
  sortFilter: ISortFilter | null;
  setSortFilter: (sortFilter: ISortFilter | null) => void;
  orderFilters: ImoduleFilter[];
  setOrderFilters: (orderFilters: ImoduleFilter[]) => void;
  listOrdersOperations: IProductList[];
  setListOrdersOperations: (listOrdersOperations: IProductList[]) => void;
  focusedOrderId: number | null;
  setFocusedOrderId: (orderId: number | null) => void;
  focusedFilterValues: IFocusedFilterValuesMap;
  setFocusedFilterValue: (filterName: string, value: TFocusedFilterValue) => void;
  resetFocusedFilterValues: () => void;
  resetOrdersOperationsState: () => void;
}

/**
 * Hook de Zustand para manejar el estado del módulo de operaciones de órdenes.
 * Gestiona filtros, ordenamiento, lista de órdenes, valores enfocados por filtro y el focus de orden.
 */
const useOrdersOperationsModule = create<IState>(set => ({
  sortFilter: { value: SORT_ORDER.DESC },
  setSortFilter: (sortFilter: ISortFilter | null) => set({ sortFilter }),
  orderFilters: [],
  setOrderFilters: (orderFilters: ImoduleFilter[]) => set({ orderFilters }),
  listOrdersOperations: [],
  setListOrdersOperations: (listOrdersOperations: IProductList[]) => set({ listOrdersOperations }),
  focusedOrderId: null,
  setFocusedOrderId: (focusedOrderId: number | null) => set({ focusedOrderId }),
  focusedFilterValues: {},
  setFocusedFilterValue: (filterName: string, value: TFocusedFilterValue) =>
    set(state => ({
      focusedFilterValues: { ...state.focusedFilterValues, [filterName]: value }
    })),
  resetFocusedFilterValues: () => set({ focusedFilterValues: {} }),
  resetOrdersOperationsState: () => {
    set({
      sortFilter: null,
      orderFilters: [],
      listOrdersOperations: [],
      focusedOrderId: null,
      focusedFilterValues: {}
    });
  }
}));

export default useOrdersOperationsModule;
